var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wide-page"},[(_vm.clinicalSolutions.length)?_c('div',[_c('vtq-clinical-solutions',{attrs:{"items":_vm.clinicalSolutions,"isFor":"clinicalSolutions","initialMode":"card"}})],1):_c('vtq-empty-results')],1)}
var staticRenderFns = []

export { render, staticRenderFns }